import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import * as API from '../../Endpoints/endpoint'

function Upload() {
  const [excelData, setExcelData] = useState([]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { defval: '' }); // if cell is empty, fill with ''
      setExcelData(data);
      console.log("Parsed Excel Data:", data);
    };

    reader.readAsBinaryString(file);
  };

const handleUpload = async () => {
  if (excelData.length === 0) {
    alert('Please upload an Excel file first.');
    return;
  }

  try {
    await axios.post(API.POST_POSTER, excelData);
    console.log("Uploaded all records successfully.");
    alert("Bulk upload completed.");
  } catch (err) {
    console.error("Bulk upload failed:", err);
    alert("Bulk upload failed. See console for details.");
  }
};


  return (
    <div style={{ padding: 20 }}>
      <h2>📑 Posters Upload via Excel</h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      <button onClick={handleUpload} style={{ marginLeft: 10 }}>📤 Upload All</button>

      {excelData.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h4>Preview:</h4>
          <pre style={{ background: '#f0f0f0', padding: 10, maxHeight: 300, overflowY: 'auto' }}>
            {JSON.stringify(excelData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

export default Upload;
